import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, styled } from '@mui/material';

const StyledTextField = styled(TextField, {
    shouldForwardProp: (prop) => prop !== 'readOnlyField',
})(({ theme, readOnlyField }) => ({
    '& .MuiInputLabel-asterisk': {
        color: 'red',
    },
    '& .MuiInputBase-input.Mui-disabled': {
        WebkitTextFillColor: theme.palette.text.primary,
    },
    ...(readOnlyField && {
        '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.grey[200],
            '& fieldset': {
                borderColor: theme.palette.grey[400],
            },
            '&:hover fieldset': {
                borderColor: theme.palette.grey[500],
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.grey[400],
            },
        },
        '& .MuiInputBase-input': {
            WebkitTextFillColor: theme.palette.text.primary,
            cursor: 'default',
        },
    }),
}));

// ----------------------------------------------------------------------

RHFViewTextField.propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
};

export default function RHFViewTextField({ name, disabled, readOnly, helperText, InputProps, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <StyledTextField
                    {...field}
                    noValidate
                    fullWidth
                    readOnlyField={readOnly}
                    error={!!error}
                    disabled={disabled}
                    InputProps={{ readOnly, ...InputProps }}
                    helperText={error?.message || helperText}
                    {...other}
                />
            )}
        />
    );
}
